import { Waypoint } from 'react-waypoint'
import { useSidebar } from '../context/SidebarContext'
import type { CardProps } from '@chakra-ui/react'

export interface CustomWaypointProps extends Waypoint.WaypointProps {
  sectionId: string | number
  formSection?: {
    id: string | number
    number: number | React.ReactNode
    sectionTitle: string | React.ReactNode
    wide?: boolean
  },
  cardProps?: CardProps
}

export const CustomWaypoint = ({
  children,
  sectionId,
  formSection,
  cardProps,
  ...rest
}: CustomWaypointProps) => {
  const { setCurrentWaypoint } = useSidebar()

  const handleEnter = () => {
    setCurrentWaypoint?.(sectionId)
  }

  return (
    <Waypoint
      topOffset="30%"
      bottomOffset="25%"
      onEnter={handleEnter}
      {...rest}
    >
      {children}
    </Waypoint>
  )
}

